<template>
  <el-row
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="320px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <div
          class="app-header-avatar-image"
          :style="{'background-image': `url(https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${organization.logo || 'profile.png'}?t=${new Date().getTime()})`}"
        />
        <h2 class="app-header-name mt-10 mb-10">
          {{ organization.name }}
        </h2>
        <el-upload
          class="app-header-avatar-uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleAvatarChange"
        >
          <el-button
            type="default"
            class="upload-button"
          >
            {{ $t('profile.change-image') }}
          </el-button>
        </el-upload>
      </el-header>
      <el-main
        v-if="!fullScreenLoading"
      >
        <el-tabs type="card">
          <el-tab-pane :label="$t('profile.title')">
            <Profile :organization="organization" />
          </el-tab-pane>
          <el-tab-pane label="Teams">
            <Teams />
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '@/views/Menu/Menu';
import Profile from './Tabs/Profile';
import Teams from './Tabs/Teams';
import { Storage } from '@aws-amplify/storage';

export default {
  name: 'Organizations',
  components: {
    Menu,
    Profile,
    Teams
  },
  data: () => ({
    fullScreenLoading: true,
    organization: {}
  }),
  created () {
    this.$adminApi.get('api/v1/entities/' + this.$route.params.id).then((response) => {
      this.organization = response.data;
      this.fullScreenLoading = false;
    });
  },
  methods: {
    handleAvatarChange (file) {
      const isCorrectType = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const sizeLimit = file.size / 1024 / 1024 < 50;

      if (!isCorrectType) {
        this.$message.error(this.$t('form.validation.avatar-format', { format: 'JPEG, PNG' }));
        return false;
      }
      if (!sizeLimit) {
        this.$message.error(this.$t('form.validation.avatar-size', { size: '50MB' }));
        return false;
      }
      this.uploadProfileAvatar(file);
    },
    uploadProfileAvatar (file) {
      this.fullScreenLoading = true;
      Storage.remove(this.organization.logo).then(() => {
        Storage.put(file.name, file.raw, { level: 'public' }).then((response) => {
          this.organization.logo = response.key;
          this.$adminApi.put('/api/v1/entities', this.organization).then((response) => {
            this.fullScreenLoading = false;
            if (response.data.status === 'Success') {
              this.$message.success(this.$t('form.item-changed', { item: 'Logo' }));
            } else {
              this.$message.warning(response.data.status);
            }
          }).catch(() => {
            this.fullScreenLoading = false;
            this.$message.error(this.$t('form.item-not-changed', { field: 'logo' }));
          });
        }).catch(() => {
          this.fullScreenLoading = false;
          this.$message.error(this.$t('form.item-not-changed', { field: 'logo' }));
        });
      }).catch(() => {
        this.fullScreenLoading = false;
        this.$message.error(this.$t('form.item-not-changed', { field: 'logo' }));
      });
    }
  }
};
</script>

<style scoped lang="scss">
.el-main {
  padding-top: 20px;
}
</style>
